<template>
  <TextInput
    :id="$attrs.id || 'zip_code'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'zip_code'"
    :label="$attrs.label || 'CEP'"
    :placeholder="$attrs.placeholder || '00000-000'"
    :helper-message="
      $attrs.helperMessage || 'Informe para identificar dados do endereço.'
    "
    :helper-size="8"
    mask="#####-###"
    inputmode="numeric"
    validations="required|min:9|cepIsValid"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'ZipCodeInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input', 'blur'],
}
</script>
<style lang="scss"></style>
